import {createErrorAction} from './utils';

const TYPES = {
    GET_REWARDS_TOP_10_GAMES: 'GET_REWARDS_TOP_10_GAMES',
    GET_REWARDS_TOP_10_GAMES_COMPLETE: 'GET_REWARDS_TOP_10_GAMES_COMPLETE',
    GET_REWARDS_TOP_10_GAMES_FAILED: 'GET_REWARDS_TOP_10_GAMES_FAILED'
};

export default {
    TYPES,

    getRewardsTop10Games: payload => ({
        type: TYPES.GET_REWARDS_TOP_10_GAMES,
        payload
    }),

    getRewardsTop10GamesSuccess: payload => ({
        type: TYPES.GET_REWARDS_TOP_10_GAMES_COMPLETE,
        payload
    }),

    getRewardsTop10GamesFailed: createErrorAction(TYPES.GET_REWARDS_TOP_10_GAMES_FAILED)
};
